import NewFacilityModalComponent from './new-facility-modal-component'
import NewFacilityModalService from './new-facility-modal-service'

/***
 * The modal that pops up allowing you to create a new facility.
 */
const newFacilityModal = angular
    .module('FacilityData.ClientEdit.NewFacilityModal', [])
    .component('newFacilityModal', NewFacilityModalComponent)
    .service('NewFacilityModalService', NewFacilityModalService)
    .name;

export default newFacilityModal;


// WEBPACK FOOTER //
// ./app/components/client-edit/new-facility-modal/new-facility-modal.js